export default __webpack_public_path__ + "static/media/email icon 001.8b60be18.png";